/**
 * Operator-facing SOP copy vs crafting labels.
 *
 * Title is an authoring/graph label only. Operators see `prompt_text`
 * (Operator instructions). Never substitute title into operator UI.
 */

const ARCHETYPES_REQUIRING_OPERATOR_INSTRUCTIONS = new Set([
  'BINARY_CHOICE',
  'MULTI_CHOICE',
  'PROMPT',
]);

export function stepRequiresOperatorInstructions(archetype: string | null | undefined): boolean {
  return ARCHETYPES_REQUIRING_OPERATOR_INSTRUCTIONS.has(String(archetype || '').toUpperCase());
}

export function hasOperatorInstructions(promptText: unknown): boolean {
  return String(promptText ?? '').trim().length > 0;
}

/** Message when a required step is saved without operator instructions. */
export const MISSING_OPERATOR_INSTRUCTIONS_MESSAGE =
  'Operator instructions are required for this step. Title is a crafting label only and is not shown to operators.';
